import React from 'react';

function Footer() {
  return (
    <footer className="footer">
      <p>© 2023 CurrencyCliQ by <a href="https://www.linkedin.com/in/dolores-crazover" target="_blank" rel="noopener noreferrer">Dolores Crazover</a></p>
    </footer>
  );
}

export default Footer;
